// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/test/styles/icon_svg.styl
// module id = 16
// module chunks = 0